import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createSlots as _createSlots } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = {
  key: 1,
  class: "importExportImport"
}
const _hoisted_3 = { class: "table-header" }
const _hoisted_4 = { class: "p-input-icon-left" }
const _hoisted_5 = /*#__PURE__*/_createVNode("i", { class: "pi pi-search" }, null, -1)
const _hoisted_6 = { class: "p-float-label kn-material-input" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { key: 1 }
const _hoisted_9 = { key: 2 }
const _hoisted_10 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FileUpload = _resolveComponent("FileUpload")
  const _component_Message = _resolveComponent("Message")
  const _component_Badge = _resolveComponent("Badge")
  const _component_InputText = _resolveComponent("InputText")
  const _component_Tag = _resolveComponent("Tag")
  const _component_Avatar = _resolveComponent("Avatar")
  const _component_Column = _resolveComponent("Column")
  const _component_DataTable = _resolveComponent("DataTable")
  const _component_TabPanel = _resolveComponent("TabPanel")
  const _component_TabView = _resolveComponent("TabView")
  const _component_Button = _resolveComponent("Button")
  const _component_Dialog = _resolveComponent("Dialog")
  const _directive_tooltip = _resolveDirective("tooltip")
  const _directive_t = _resolveDirective("t")

  return (_openBlock(), _createBlock(_component_Dialog, {
    class: "kn-dialog--toolbar--primary importExportDialog",
    visible: _ctx.visibility,
    footer: "footer",
    header: _ctx.$t('common.import'),
    closable: false,
    modal: ""
  }, {
    footer: _withCtx(() => [
      _createVNode(_component_Button, {
        visible: _ctx.visibility,
        class: "p-button-text kn-button thirdButton",
        label: _ctx.$t('common.cancel'),
        onClick: _ctx.resetAndClose
      }, null, 8, ["visible", "label", "onClick"]),
      (_ctx.step == 0)
        ? _withDirectives((_openBlock(), _createBlock(_component_Button, {
            key: 0,
            visible: _ctx.visibility,
            class: "kn-button kn-button--primary",
            disabled: _ctx.uploadedFiles && _ctx.uploadedFiles.length == 0,
            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.goToChooseElement(_ctx.uploadedFiles)))
          }, null, 8, ["visible", "disabled"])), [
            [_directive_t, 'common.next']
          ])
        : _createCommentVNode("", true),
      (_ctx.step == 1)
        ? (_openBlock(), _createBlock("span", _hoisted_10, [
            _withDirectives(_createVNode(_component_Button, {
              visible: _ctx.visibility,
              class: "kn-button kn-button--secondary",
              onClick: _ctx.resetToFirstStep
            }, null, 8, ["visible", "onClick"]), [
              [_directive_t, 'common.back']
            ]),
            _withDirectives(_createVNode(_component_Button, {
              visible: _ctx.visibility,
              class: "kn-button kn-button--primary",
              disabled: _ctx.isImportDisabled(),
              onClick: _ctx.startImport
            }, null, 8, ["visible", "disabled", "onClick"]), [
              [_directive_t, 'common.import']
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    default: _withCtx(() => [
      (_ctx.step == 0)
        ? (_openBlock(), _createBlock("div", _hoisted_1, [
            _createVNode(_component_FileUpload, {
              name: "demo[]",
              chooseLabel: _ctx.$t('common.choose'),
              customUpload: true,
              onUploader: _ctx.onUpload,
              onRemove: _ctx.onDelete,
              auto: "true",
              maxFileSize: 10000000,
              accept: "application/zip, application/x-zip-compressed",
              multiple: false,
              fileLimit: 1
            }, {
              empty: _withCtx(() => [
                _createVNode("p", null, _toDisplayString(_ctx.$t('common.dragAndDropFileHere')), 1)
              ]),
              _: 1
            }, 8, ["chooseLabel", "onUploader", "onRemove"])
          ]))
        : _createCommentVNode("", true),
      (_ctx.step == 1)
        ? (_openBlock(), _createBlock("div", _hoisted_2, [
            (_ctx.step == 1 && _ctx.getMessageWarningCondition())
              ? (_openBlock(), _createBlock(_component_Message, {
                  key: 0,
                  severity: "warn"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('importExport.itemsWithEmptyIdWarning')), 1)
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            _createVNode(_component_TabView, { onChange: _ctx.resetSearchFilter }, {
              default: _withCtx(() => [
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.importExportDescriptor.functionalities, (functionality) => {
                  return (_openBlock(), _createBlock(_component_TabPanel, {
                    key: functionality.label
                  }, {
                    header: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t(functionality.label).toUpperCase()) + " ", 1),
                      (_ctx.selectedItems[functionality.type].length && _ctx.selectedItems[functionality.type].length > 0)
                        ? (_openBlock(), _createBlock(_component_Badge, {
                            key: 0,
                            class: "p-ml-1",
                            value: _ctx.selectedItems[functionality.type].length
                          }, null, 8, ["value"]))
                        : _createCommentVNode("", true)
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_component_DataTable, {
                        ref: "dt",
                        value: _ctx.packageItems[functionality.type],
                        selection: _ctx.selectedItems[functionality.type],
                        "onUpdate:selection": ($event: any) => (_ctx.selectedItems[functionality.type] = $event),
                        filters: _ctx.filters,
                        "onUpdate:filters": _cache[2] || (_cache[2] = ($event: any) => (_ctx.filters = $event)),
                        class: "p-datatable-sm kn-table functionalityTable",
                        dataKey: "id",
                        paginator: true,
                        rows: 10,
                        paginatorTemplate: "FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown",
                        responsiveLayout: "stack",
                        breakpoint: "960px",
                        currentPageReportTemplate: _ctx.$t('common.table.footer.paginated', { first: '{first}', last: '{last}', totalRecords: '{totalRecords}' }),
                        globalFilterFields: ['name', 'type', 'tags'],
                        loading: _ctx.loading
                      }, {
                        header: _withCtx(() => [
                          _createVNode("div", _hoisted_3, [
                            _createVNode("span", _hoisted_4, [
                              _hoisted_5,
                              _createVNode(_component_InputText, {
                                class: "kn-material-input",
                                type: "text",
                                modelValue: _ctx.filters['global'].value,
                                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.filters['global'].value = $event)),
                                placeholder: _ctx.$t('common.search'),
                                badge: "0"
                              }, null, 8, ["modelValue", "placeholder"])
                            ])
                          ])
                        ]),
                        empty: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t('common.info.noDataFound')), 1)
                        ]),
                        loading: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t('common.info.dataLoading')), 1)
                        ]),
                        default: _withCtx(() => [
                          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.getData(functionality.type), (col) => {
                            return (_openBlock(), _createBlock(_component_Column, {
                              field: col.field,
                              header: _ctx.$t(col.header),
                              key: col.field,
                              style: col.style,
                              selectionMode: col.field == 'selectionMode' ? 'multiple' : '',
                              exportable: col.field == 'selectionMode' ? false : ''
                            }, _createSlots({ _: 2 }, [
                              (col.displayType)
                                ? {
                                    name: "body",
                                    fn: _withCtx(({data}) => [
                                      _createVNode("span", _hoisted_6, [
                                        (col.displayType == 'widgetTags')
                                          ? (_openBlock(), _createBlock("div", _hoisted_7, [
                                              (_openBlock(true), _createBlock(_Fragment, null, _renderList(data.tags, (tag, index) => {
                                                return (_openBlock(), _createBlock(_component_Tag, {
                                                  class: "importExportTags p-mr-1",
                                                  key: index,
                                                  rounded: "",
                                                  value: tag
                                                }, null, 8, ["value"]))
                                              }), 128))
                                            ]))
                                          : (col.displayType == 'widgetGalleryType')
                                            ? (_openBlock(), _createBlock("div", _hoisted_8, [
                                                _createVNode(_component_Tag, {
                                                  style: _ctx.importExportDescriptor.iconTypesMap[data.type].style
                                                }, {
                                                  default: _withCtx(() => [
                                                    _createTextVNode(_toDisplayString(data.type.toUpperCase()), 1)
                                                  ]),
                                                  _: 2
                                                }, 1032, ["style"])
                                              ]))
                                            : (col.displayType == 'widgetInfo')
                                              ? (_openBlock(), _createBlock("div", _hoisted_9, [
                                                  (data.id === null || data.id === '')
                                                    ? _withDirectives((_openBlock(), _createBlock(_component_Avatar, {
                                                        key: 0,
                                                        icon: "pi pi-exclamation-triangle",
                                                        shape: "circle"
                                                      }, null, 512)), [
                                                        [_directive_tooltip, _ctx.$t('importExport.itemWithEmptyId')]
                                                      ])
                                                    : _createCommentVNode("", true)
                                                ]))
                                              : _createCommentVNode("", true)
                                      ])
                                    ])
                                  }
                                : undefined
                            ]), 1032, ["field", "header", "style", "selectionMode", "exportable"]))
                          }), 128))
                        ]),
                        _: 2
                      }, 1032, ["value", "selection", "onUpdate:selection", "filters", "currentPageReportTemplate", "loading"])
                    ]),
                    _: 2
                  }, 1024))
                }), 128))
              ]),
              _: 1
            }, 8, ["onChange"])
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["visible", "header"]))
}